(function(){
  function pad(n){ return n < 10 ? '0' + n : '' + n; }

  function startClock(sec){
    var el = sec.querySelector('[data-kz-clock]');
    if(!el) return;
    function tick(){
      var d = new Date();
      var date = pad(d.getMonth()+1) + '/' + pad(d.getDate()) + '/' + d.getFullYear();
      var h = d.getHours(); var ap = h >= 12 ? 'PM' : 'AM';
      h = h % 12; if(h === 0){ h = 12; }
      var tz = '';
      try{
        var p = new Intl.DateTimeFormat('en-US',{timeZoneName:'short'}).formatToParts(d);
        for(var i=0;i<p.length;i++){ if(p[i].type === 'timeZoneName'){ tz = p[i].value; } }
      }catch(e){}
      el.textContent = date + '  ' + h + ':' + pad(d.getMinutes()) + ' ' + ap + (tz ? ' ' + tz : '');
    }
    tick();
    setInterval(tick, 1000);
  }

  function startContrast(sec){
    var ov = parseFloat(sec.dataset.kzOv || '0');
    var ovLum = parseFloat(sec.dataset.kzOvlum || '0');
    var bgLum = parseFloat(sec.dataset.kzBglum || '255');
    var canInvert = sec.dataset.kzInvert === 'true';

    function apply(lum){
      var eff = lum * (1 - ov) + ovLum * ov;
      var darkText = eff > 140;
      var col = darkText ? '#111111' : '#ffffff';
      sec.style.setProperty('--kzmenu', col);
      sec.style.setProperty('--kzmeta', col);
      sec.style.setProperty('--kzhalo', darkText ? 'rgba(255,255,255,.55)' : 'rgba(0,0,0,.45)');
      sec.classList.toggle('kz-dark', !darkText);

      var links = sec.querySelectorAll('.kznav a, .kzmeta, .kzlogo-text');
      for(var i=0;i<links.length;i++){ links[i].style.color = col; }

      var logo = sec.querySelector('.kzlogo');
      if(logo && canInvert){ logo.style.filter = darkText ? '' : 'invert(1)'; }
    }

    function visibleMedia(){
      var nodes = sec.querySelectorAll('.kzmedia');
      for(var i=0;i<nodes.length;i++){
        if(nodes[i].offsetWidth > 0 || nodes[i].offsetHeight > 0) return nodes[i];
      }
      return null;
    }

    function measure(){
      var box = visibleMedia();
      if(!box){ apply(bgLum); return; }
      if(box.querySelector('video')){ apply(50); return; }
      var im = box.querySelector('img');
      if(!im){ apply(bgLum); return; }
      function go(){
        try{
          var c = document.createElement('canvas');
          c.width = 24; c.height = 24;
          var x = c.getContext('2d');
          x.drawImage(im, 0, 0, 24, 24);
          var d = x.getImageData(0, 0, 24, 24).data, s = 0, n = 0;
          for(var i=0;i<d.length;i+=4){ s += (d[i]*299 + d[i+1]*587 + d[i+2]*114) / 1000; n++; }
          apply(s / n);
        }catch(e){ apply(50); }
      }
      if(im.complete && im.naturalWidth){ go(); } else { im.addEventListener('load', go); }
    }

    measure();
    var t;
    window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(measure, 200); });
  }

  function init(sec){
    if(sec.getAttribute('data-kz-ready') === '1') return;
    sec.setAttribute('data-kz-ready', '1');
    if(sec.dataset.kzClock === 'true') startClock(sec);
    if(sec.dataset.kzAuto === 'true') startContrast(sec);
  }

  function boot(){
    var list = document.querySelectorAll('.kz-home');
    for(var i=0;i<list.length;i++){ init(list[i]); }
  }

  if(document.readyState !== 'loading'){ boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function(){ setTimeout(boot, 60); });
})();